// extracted by mini-css-extract-plugin
export default {"layout":"nBmg4mWLTzGZRGOJ9ks9","mainContent":"RRha_wvXz0hDW_1D71HK","register":"vG8vuHFw6BLQaFBeRlYg","fixed":"rNJdH9PS2exat9O8cRgA"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"layout\":\"nBmg4mWLTzGZRGOJ9ks9\",\"mainContent\":\"RRha_wvXz0hDW_1D71HK\",\"register\":\"vG8vuHFw6BLQaFBeRlYg\",\"fixed\":\"rNJdH9PS2exat9O8cRgA\"}";
        // 1793273552911
        var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  